import axios from "axios"
import * as env from "../constants/env"


/* List Notes */
export const notes = (data) => {
    const uri = `${env.startpoint}note/list`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}

/* Create Notes */
export const create = (data) => {
    const uri = `${env.startpoint}note/create`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}

/* Every Note Of The Scope — the modal of the dashboard */
export const all = ({ page = 1, table = "", search = "" }) => {
    const query = new URLSearchParams({ page, table, search }).toString()
    const uri = `${env.startpoint}note/all?${query}`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.get(uri, headers).then((response) => response).catch((data) => data.response)
}